import { render } from "./IncomingProducts.vue?vue&type=template&id=f61e20e4"
import script from "./IncomingProducts.vue?vue&type=script&lang=js"
export * from "./IncomingProducts.vue?vue&type=script&lang=js"

import exportComponent from "/builds/weborigo-projects/vivien-vance/core-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__